import { jsx as t, jsxs as v, Fragment as j } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Le, AlertActionCloseButton as nn, Page as rn, Modal as Ct, ModalVariant as an, TextContent as ln, Text as Ce, Button as N, Spinner as kt, FormHelperText as We, HelperText as je, HelperTextItem as Ge, Popover as on, Icon as Be, FormGroup as It, NumberInput as sn, ValidatedOptions as K, InputGroup as xe, InputGroupItem as Ne, TextInput as Se, Select as Te, SelectList as Ee, SelectOption as ze, MenuToggle as me, MenuToggleStatus as Je, TextInputGroup as wt, TextInputGroupMain as xt, ChipGroup as Ye, Chip as Qe, TextInputGroupUtilities as St, Switch as cn, TextArea as Tt, FileUpload as dn, Title as un, Card as hn, CardHeader as mn, CardTitle as pn, CardBody as fn, Grid as gn, GridItem as ot, PageSection as yn, JumpLinks as bn, JumpLinksItem as vn, ButtonVariant as Ie, Checkbox as Cn, Radio as kn, MenuFooter as In, Dropdown as wn, DropdownList as xn, DropdownItem as st, Masthead as Sn, MastheadToggle as Tn, PageToggleButton as En, MastheadBrand as An, MastheadContent as Rn, Toolbar as ke, ToolbarContent as _e, ToolbarItem as W, Avatar as Dn, Bullseye as On, EmptyState as Fn, EmptyStateIcon as ct, EmptyStateHeader as Pn, EmptyStateBody as Vn, EmptyStateFooter as Mn, EmptyStateActions as Ln, SearchInput as Bn, Divider as Nn, Pagination as _n, Badge as qn } from "@patternfly/react-core";
import { createContext as Et, useContext as At, useRef as J, useEffect as le, useCallback as he, useState as E, useMemo as q, forwardRef as $n, useId as Rt, Fragment as Dt, Children as Ot, Component as Un, isValidElement as Kn } from "react";
import { useTranslation as _ } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Hn from "keycloak-js";
import { ExclamationCircleIcon as Wn, HelpIcon as dt, EyeIcon as jn, EyeSlashIcon as Gn, TimesIcon as Pt, CubeIcon as zn, PaypalIcon as Jn, InstagramIcon as Yn, BitbucketIcon as Qn, MicrosoftIcon as Xn, TwitterIcon as Zn, StackOverflowIcon as er, OpenshiftIcon as tr, LinkedinIcon as nr, GoogleIcon as rr, GitlabIcon as ar, FacebookSquareIcon as lr, GithubIcon as ir, MinusCircleIcon as or, PlusCircleIcon as Vt, EllipsisVIcon as sr, BarsIcon as cr, SearchIcon as dr, SyncAltIcon as ur } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as ie, useController as Re, FormProvider as hr, useWatch as mr } from "react-hook-form";
import { get as B, intersectionBy as pr, cloneDeep as fr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as gr } from "@patternfly/react-styles";
import { Table as yr, TableVariant as br, Thead as vr, Tr as ve, Th as Ve, Tbody as ut, Td as re, ExpandableRowContent as Cr, ActionsColumn as kr, TableText as Ir } from "@patternfly/react-table";
import './main.css';function Xe(e, n) {
  const r = Et(n);
  return r.displayName = e, r;
}
const wr = ["error", "errorMessage"], Me = "error_description";
function xr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Mt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Sr(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Tr(n);
}
function Tr(e) {
  if (typeof e == "object" && e !== null && Me in e && typeof e[Me] == "string")
    return e[Me];
}
function Mt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of wr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Er = () => Math.floor(Math.random() * 1e3);
function Ar(e) {
  return e != null;
}
function Ze(e) {
  const n = At(e);
  if (Ar(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Rr() {
  const e = J(!1), n = J(/* @__PURE__ */ new Set());
  le(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(o, l));
    n.current.add(i);
    function o() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Dr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, o) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": o === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Le[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Or = 8e3, Lt = Xe(
  "AlertContext",
  void 0
), _a = () => Ze(Lt), Fr = ({ children: e }) => {
  const { t: n } = _(), r = Rr(), [a, l] = E([]), i = (u) => l((h) => h.filter((c) => c.id !== u)), o = he(
    (u, h = Le.success, c) => {
      const y = {
        id: Er(),
        message: u,
        variant: h,
        description: c
      };
      l((g) => [y, ...g]), r(() => i(y.id), Or);
    },
    [r]
  ), s = he(
    (u, h) => {
      const c = n(u, { error: xr(h) }), y = Sr(h);
      o(c, Le.danger, y);
    },
    [o, n]
  ), d = q(() => ({ addAlert: o, addError: s }), [o, s]);
  return /* @__PURE__ */ v(Lt.Provider, { value: d, children: [
    /* @__PURE__ */ t(Dr, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Pr = (e) => {
  const { t: n, i18n: r } = _(), a = e.error, l = Vr(a), i = Mt(a);
  console.error(a);
  function o() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    Ct,
    {
      variant: an.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(N, { variant: "primary", onClick: o, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: l ? /* @__PURE__ */ t(Ce, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(Ce, { children: n(i) }) : /* @__PURE__ */ t(Ce, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Vr(e) {
  return e instanceof Error ? e.message : null;
}
function Mr(e, n, r) {
  const [a, l] = E(
    () => e.getItem(n) ?? r
  ), i = he((o) => {
    l(o), e.setItem(n, o);
  }, []);
  return le(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", o);
    function o(s) {
      s.storageArea === e && (s.key === null || s.key === n) && l(s.newValue ?? r);
    }
    return () => window.removeEventListener("storage", o);
  }, [e, n]), [a, i];
}
function Bt(e, n, r) {
  const a = q(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Mr(
    e,
    n,
    a
  ), o = q(() => JSON.parse(l), [l]), s = he(
    (d) => i(JSON.stringify(d)),
    []
  );
  return [o, s];
}
const Nt = Xe(
  "HelpContext",
  void 0
), Lr = () => Ze(Nt), Br = ({ children: e }) => {
  const [n, r] = Bt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Nt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, Nr = () => Et(void 0);
let qe;
const qa = () => {
  const e = At(qe);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, $a = ({
  environment: e,
  children: n
}) => {
  qe = Nr();
  const r = J(!1), [a, l] = E(!1), [i, o] = E(), s = q(() => {
    const d = new Hn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return d.onAuthLogout = () => d.login(), d;
  }, [e]);
  return le(() => {
    if (r.current)
      return;
    s.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => l(!0)).catch((u) => o(u)), r.current = !0;
  }, [s]), i ? /* @__PURE__ */ t(Pr, { error: i }) : a ? /* @__PURE__ */ t(qe.Provider, { value: { environment: e, keycloak: s }, children: /* @__PURE__ */ t(Fr, { children: /* @__PURE__ */ t(Br, { children: n }) }) }) : /* @__PURE__ */ t(kt, {});
};
function Ua() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ka = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: o,
  onContinue: s,
  component: d = N,
  children: u,
  ...h
}) => {
  const [c, y] = E(!1);
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(
      d,
      {
        variant: i,
        onClick: () => y(!0),
        isDisabled: l,
        "data-testrole": o,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      Ct,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: c,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ t(
            N,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), s();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            N,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: u
      }
    )
  ] });
}, _t = ({ message: e, ...n }) => /* @__PURE__ */ t(We, { ...n, children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { icon: /* @__PURE__ */ t(Wn, {}), variant: "error", children: e }) }) }), qt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1
}) => {
  const { enabled: l } = Lr();
  return l ? /* @__PURE__ */ t(on, { bodyContent: e, children: /* @__PURE__ */ v(j, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (i) => i.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(Be, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
      }
    ),
    a && /* @__PURE__ */ t(Be, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
  ] }) }) : null;
};
function oe(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Y = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...o
}) => /* @__PURE__ */ v(
  It,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: a ? /* @__PURE__ */ t(qt, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...o,
    children: [
      i,
      l && /* @__PURE__ */ t(_t, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), Ha = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: o }
  } = Ae();
  return /* @__PURE__ */ t(
    Y,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: o[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: s }) => {
            const d = !!r.rules?.required, u = oe(r.rules?.min), h = s.value ?? r.defaultValue, c = (y) => s.onChange(
              u !== void 0 ? Math.max(y, Number(u)) : y
            );
            return /* @__PURE__ */ t(
              sn,
              {
                ...l,
                id: e,
                value: h,
                validated: o[e] ? K.error : K.default,
                required: d,
                min: Number(u),
                max: Number(r.rules?.max),
                onPlus: () => c(h + 1),
                onMinus: () => c(h - 1),
                onChange: (y) => {
                  const g = Number(y.currentTarget.value);
                  c(isNaN(g) ? r.defaultValue : g);
                }
              }
            );
          }
        }
      )
    }
  );
}, _r = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = _(), [l, i] = E(!0);
  return /* @__PURE__ */ v(xe, { children: [
    /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
      Se,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      N,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(jn, {}) : /* @__PURE__ */ t(Gn, {})
      }
    )
  ] });
}, $t = $n(
  (e, n) => /* @__PURE__ */ t(_r, { ...e, innerRef: n })
);
$t.displayName = "PasswordInput";
const Wa = (e) => {
  const { labelIcon: n, ...r } = e, a = !!oe(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: o } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ v(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          $t,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: o.error ? K.error : K.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { children: e.helperText }) }) })
      ]
    }
  );
}, qr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  isDisabled: s,
  onSelect: d,
  ...u
}) => {
  const {
    control: h,
    formState: { errors: c }
  } = Ae(), [y, g] = E(!1), C = oe(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: C,
      error: B(c, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: h,
          render: ({ field: { onChange: R, value: p } }) => /* @__PURE__ */ t(
            Te,
            {
              ...u,
              variant: "default",
              onClick: () => g(!y),
              onOpenChange: () => g(!1),
              selected: te(a) ? a.filter(
                (m) => Array.isArray(p) ? p.includes(m.key) : p === m.key
              ).map((m) => m.value) : p,
              toggle: (m) => /* @__PURE__ */ t(
                me,
                {
                  id: e || n,
                  ref: m,
                  onClick: () => g(!y),
                  isExpanded: y,
                  isFullWidth: !0,
                  status: B(c, n) ? Je.danger : void 0,
                  "aria-label": r,
                  isDisabled: s,
                  children: te(a) ? a.find(
                    (S) => S.key === (Array.isArray(p) ? p[0] : p)
                  )?.value : p
                }
              ),
              onSelect: (m, S) => {
                const T = S?.toString(), I = Array.isArray(p) ? [T] : T;
                d ? d(I, R) : R(I), g(!1);
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: [...a, ...l].map((m) => /* @__PURE__ */ t(ze, { value: ae(m), children: et(m) ? m : m.value }, ae(m))) })
            }
          )
        }
      )
    }
  );
}, ee = (e) => et(e) ? e : e.value, $r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  placeholderText: s,
  onFilter: d,
  variant: u,
  ...h
}) => {
  const {
    control: c,
    formState: { errors: y }
  } = Ae(), [g, C] = E(!1), [R, p] = E(""), [m, S] = E(0), [T, I] = E([]), b = J(), x = oe(i.rules?.required) === !0, F = u === ue.typeaheadMulti, A = q(
    () => [
      ...a.filter(
        (f) => !l.map((k) => ee(k)).includes(ee(f))
      ),
      ...l
    ],
    [l, a]
  ), L = A.filter(
    (f) => ee(f).toLowerCase().startsWith(R.toLowerCase())
  ), H = (f, k) => {
    k.value.includes(f) ? (k.onChange(k.value.filter((D) => D !== f)), te(a) && I(
      T.filter((D) => D.key !== f)
    )) : (k.onChange([...k.value, f]), te(A) && I([
      ...T,
      A.find((D) => D.key === f)
    ]));
  }, V = (f, k) => {
    const D = L[m];
    switch (C(!0), f.key) {
      case "Enter": {
        f.preventDefault(), p(F ? "" : ee(D)), H(ae(D), k), C(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        C(!1), k.onChange(void 0);
        break;
      }
      case "Backspace": {
        u === ue.typeahead && k.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        f.preventDefault();
        let O = 0;
        f.key === "ArrowUp" && (m === 0 ? O = a.length - 1 : O = m - 1), f.key === "ArrowDown" && (m === a.length - 1 ? O = 0 : O = m + 1), S(O);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: x,
      error: B(y, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: c,
          render: ({ field: f }) => /* @__PURE__ */ t(
            Te,
            {
              ...h,
              onOpenChange: () => C(!1),
              selected: te(A) ? A.filter(
                (k) => Array.isArray(f.value) ? f.value.includes(k.key) : f.value === k.key
              ).map((k) => k.value) : f.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (k) => /* @__PURE__ */ t(
                me,
                {
                  ref: k,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    C(!g), b.current?.focus();
                  },
                  isExpanded: g,
                  isFullWidth: !0,
                  status: B(y, n) ? Je.danger : void 0,
                  children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      xt,
                      {
                        placeholder: s,
                        value: u === ue.typeahead && f.value ? te(A) ? A.find(
                          (D) => D.key === (Array.isArray(f.value) ? f.value[0] : f.value)
                        )?.value : f.value : R,
                        onClick: () => C(!g),
                        onChange: (D, O) => {
                          p(O), d?.(O);
                        },
                        onKeyDown: (D) => V(D, f),
                        autoComplete: "off",
                        innerRef: b,
                        role: "combobox",
                        isExpanded: g,
                        "aria-controls": "select-typeahead-listbox",
                        children: u === ue.typeaheadMulti && Array.isArray(f.value) && /* @__PURE__ */ t(Ye, { "aria-label": "Current selections", children: f.value.map(
                          (D, O) => /* @__PURE__ */ t(
                            Qe,
                            {
                              onClick: (se) => {
                                se.stopPropagation(), f.onChange(
                                  f.value.filter(
                                    ($) => $ !== ae(D)
                                  )
                                );
                              },
                              children: te(A) ? [
                                ...A,
                                ...T
                              ].find((se) => D === se.key)?.value : ee(D)
                            },
                            O
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(St, { children: (!!R || f.value) && /* @__PURE__ */ t(
                      N,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), f.onChange(F ? [] : ""), b?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (k, D) => {
                k?.stopPropagation();
                const O = D?.toString();
                F && Array.isArray(f.value) ? (p(""), H(O || "", f)) : (f.onChange(Array.isArray(f.value) ? [O] : O), C(!1));
              },
              isOpen: g,
              children: /* @__PURE__ */ t(Ee, { children: L.map((k, D) => /* @__PURE__ */ t(
                ze,
                {
                  value: ae(k),
                  isFocused: m === D,
                  isActive: f.value.includes(ee(k)),
                  children: ee(k)
                },
                ae(k)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const te = (e) => typeof e[0] != "string", et = (e) => typeof e == "string", ae = (e) => et(e) ? e : e.key, Ur = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(qr, { ...n }) : /* @__PURE__ */ t($r, { ...n, variant: e }), $e = (e) => e && typeof e == "string" ? e.includes("${") : !1, Ue = (e) => e.substring(2, e.length - 1), ne = (e, n, r, a) => {
  const l = n || r, i = $e(l) ? Ue(l) : l, o = a ? `${a}.${i}` : i;
  return e(o || "");
}, Ke = (e, n) => ne(e, n.displayName, n.name), Kr = ["username", "firstName", "lastName", "email"], Ut = (e) => e && Kr.includes(e), Q = (e) => `${Ut(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, ja = (e) => e.replaceAll(".", "🍺"), Hr = (e) => e.replaceAll("🍺", ".");
function Ga(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => $e(i) ? r(Ue(i)) : i)
    );
    n(Q(a.field), {
      message: r(
        $e(a.errorMessage) ? Ue(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function De({
  required: e
}) {
  return e;
}
function za(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ht(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ht);
}
function ht(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Ja = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const o = r ?? (n ? "false" : !1), { control: s } = Ae();
  return /* @__PURE__ */ t(
    Y,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          control: s,
          name: l.name,
          defaultValue: o,
          render: ({ field: { onChange: d, value: u } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": Hr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? u === "true" : u,
              onChange: (h, c) => {
                const y = n ? c.toString() : c;
                l.onChange?.(h, c), d(y);
              }
            }
          )
        }
      )
    }
  );
}, Ya = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Re({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Y,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        Tt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? K.error : K.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Qa = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!oe(e.rules?.required), i = e.defaultValue ?? "", { field: o, fieldState: s } = Re({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ v(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          Se,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: s.error ? K.error : K.default,
            isDisabled: e.isDisabled,
            ...a,
            ...o
          }
        ),
        r && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { children: r }) }) })
      ]
    }
  );
}, Wr = Tt, Xa = (e) => {
  const { labelIcon: n, ...r } = e, a = !!oe(e.rules?.required), l = e.defaultValue ?? "", { t: i } = _(), [o, s] = E(""), { field: d, fieldState: u } = Re({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: u.error,
      children: /* @__PURE__ */ t(
        dn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: o,
          browseButtonText: i("browse"),
          validated: u.error ? K.error : K.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (h, c) => {
            d.onChange(c), s(c.name);
          },
          onClearClick: () => {
            d.onChange(null), s("");
          },
          ...r,
          ...d
        }
      )
    }
  );
}, Za = ({ icon: e }) => {
  const n = jr(e);
  return /* @__PURE__ */ t(Be, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function jr(e) {
  switch (e) {
    case "github":
      return ir;
    case "facebook":
      return lr;
    case "gitlab":
      return ar;
    case "google":
      return rr;
    case "linkedin":
    case "linkedin-openid-connect":
      return nr;
    case "openshift-v4":
      return tr;
    case "stackoverflow":
      return er;
    case "twitter":
      return Zn;
    case "microsoft":
      return Xn;
    case "bitbucket":
      return Qn;
    case "instagram":
      return Yn;
    case "paypal":
      return Jn;
    default:
      return zn;
  }
}
const Gr = "_title_180i0_2", zr = {
  title: Gr
}, Kt = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  un,
  {
    headingLevel: r,
    size: a,
    className: zr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Jr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Rt();
  return /* @__PURE__ */ v(hn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t(Kt, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(fn, { className: "kc-form-panel__body", children: n })
  ] });
}, Yr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(Kt, { id: a, title: n }),
    r
  ] }) });
}, Qr = "_panel_1cdve_1", Xr = "_sticky_1cdve_5", mt = {
  panel: Qr,
  sticky: Xr
}, Zr = "kc-main-content-page-container", pt = (e) => e.replace(/\s+/g, "-"), ea = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = q(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ v(gn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(ot, { md: 8, sm: 12, children: l.map(({ title: i, panel: o }) => {
      const s = pt(i.toLowerCase());
      return /* @__PURE__ */ t(Dt, { children: r ? /* @__PURE__ */ t(
        Jr,
        {
          scrollId: s,
          title: i,
          className: mt.panel,
          children: o
        }
      ) : /* @__PURE__ */ t(Yr, { scrollId: s, title: i, children: o }) }, i);
    }) }),
    /* @__PURE__ */ t(ot, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(yn, { className: mt.sticky, children: /* @__PURE__ */ t(
      bn,
      {
        isVertical: !0,
        scrollableSelector: `#${Zr}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const o = pt(i.toLowerCase());
          return /* @__PURE__ */ t(
            vn,
            {
              onClick: () => {
                const s = document.getElementById(o);
                s && s.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${o}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, ta = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, el = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  N,
  {
    variant: "primary",
    isDisabled: e && !ta(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), na = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, ra = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = q(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, na(i) ?? i)
    })).sort((i, o) => i.value.localeCompare(o.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(hr, { ...n, children: /* @__PURE__ */ t(
    Ur,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, pe = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ne(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: o }
  } = n, s = a?.(r), d = B(o, Q(r.name));
  return /* @__PURE__ */ v(
    It,
    {
      label: Ke(e, r) || "",
      fieldId: r.name,
      isRequired: De(r),
      labelIcon: i ? /* @__PURE__ */ t(qt, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        s ? /* @__PURE__ */ v(xe, { children: [
          l,
          s
        ] }) : l,
        d && /* @__PURE__ */ t(
          _t,
          {
            "data-testid": `${r.name}-helper`,
            message: d.message
          }
        )
      ]
    },
    r.name
  );
}, aa = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(pe, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  la,
  {
    t: e,
    form: n,
    "aria-label": Ke(e, r),
    name: Q(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ke(e, r)
    }),
    ...l
  }
) }), la = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: o,
  id: s,
  ...d
}) => {
  const { register: u, setValue: h, control: c } = a, y = mr({
    name: n,
    control: c,
    defaultValue: o || ""
  }), g = q(() => Array.isArray(y) && y.length !== 0 ? y : o || [""], [y]), C = (T) => {
    m([...g.slice(0, T), ...g.slice(T + 1)]);
  }, R = () => {
    m([...g, ""]);
  }, p = (T, I) => {
    m([...g.slice(0, T), I, ...g.slice(T + 1)]);
  }, m = (T) => {
    const I = T.flatMap((b) => b);
    h(n, I, {
      shouldDirty: !0
    });
  }, S = r.startsWith("html") ? r.substring(6) : "text";
  return le(() => {
    u(n);
  }, [u]), /* @__PURE__ */ t("div", { id: s, children: g.map((T, I) => /* @__PURE__ */ v(Dt, { children: [
    /* @__PURE__ */ v(xe, { children: [
      /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
        Se,
        {
          "data-testid": n + I,
          onChange: (b, x) => p(I, x),
          name: `${n}.${I}.value`,
          value: T,
          isDisabled: i,
          type: S,
          ...d
        }
      ) }),
      /* @__PURE__ */ t(Ne, { children: /* @__PURE__ */ t(
        N,
        {
          "data-testid": "remove" + I,
          variant: Ie.link,
          onClick: () => C(I),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: g.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    I === g.length - 1 && /* @__PURE__ */ v(
      N,
      {
        variant: Ie.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !T || i,
        children: [
          /* @__PURE__ */ t(Vt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, I)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = De(a), i = r.startsWith("multiselect"), o = i ? Cn : kn, s = a.validators?.options?.options || [], d = a.annotations?.inputOptionLabels || {}, u = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Q(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: h }) => /* @__PURE__ */ t(j, { children: s.map((c) => /* @__PURE__ */ t(
        o,
        {
          id: c,
          "data-testid": c,
          label: ne(e.t, d[c], c, u),
          value: c,
          isChecked: h.value?.includes(c),
          onChange: () => {
            i ? h.value?.includes(c) ? h.onChange(
              h.value?.filter((y) => y !== c)
            ) : h.onChange([...h.value || [], c]) : h.onChange([c]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        c
      )) })
    }
  ) });
}, ia = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: o,
  width: s,
  maxHeight: d,
  toggleIcon: u,
  className: h,
  isDisabled: c,
  children: y,
  ...g
}) => {
  const [C, R] = E(!1), p = J(), m = () => {
    R(!C), n(!C);
  }, S = () => i === "parent" && p.current?.parentElement || "inline", T = Ot.toArray(
    y
  );
  return /* @__PURE__ */ t(
    Te,
    {
      ref: p,
      maxMenuHeight: we(d),
      isScrollable: !0,
      popperProps: {
        appendTo: S(),
        direction: o,
        width: we(s)
      },
      ...g,
      onClick: m,
      onOpenChange: (I) => {
        I !== C && m();
      },
      selected: a,
      onSelect: (I, b) => {
        r?.(b || ""), m();
      },
      toggle: (I) => /* @__PURE__ */ t(
        me,
        {
          id: e,
          ref: I,
          className: h,
          onClick: m,
          isExpanded: l,
          "aria-label": g["aria-label"],
          icon: u,
          isDisabled: c,
          isFullWidth: !0,
          children: T.find((b) => b.props.value === a)?.props.children || a || g["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ee, { children: y })
    }
  );
}, oa = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: o,
  maxHeight: s,
  width: d,
  toggleIcon: u,
  direction: h,
  selections: c,
  typeAheadAriaLabel: y,
  chipGroupComponent: g,
  chipGroupProps: C,
  footer: R,
  isDisabled: p,
  children: m,
  ...S
}) => {
  const [T, I] = E(""), [b, x] = E(0), F = J(), A = Ot.toArray(
    m
  ), L = () => {
    r?.(!S.isOpen);
  }, H = (V) => {
    const f = A[b];
    switch (r?.(!0), V.key) {
      case "Enter": {
        V.preventDefault(), l !== z.typeaheadMulti ? I(f.props.value) : I(""), n?.(f.props.value), r?.(!1), x(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === z.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        V.preventDefault();
        let k = 0;
        V.key === "ArrowUp" && (b === 0 ? k = A.length - 1 : k = b - 1), V.key === "ArrowDown" && (b === A.length - 1 ? k = 0 : k = b + 1), x(k);
        break;
      }
    }
  };
  return /* @__PURE__ */ v(
    Te,
    {
      ...S,
      onClick: L,
      onOpenChange: (V) => r?.(V),
      onSelect: (V, f) => {
        n?.(f || ""), a?.(""), I("");
      },
      maxMenuHeight: we(s),
      popperProps: { direction: h, width: we(d) },
      toggle: (V) => /* @__PURE__ */ t(
        me,
        {
          ref: V,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: u,
          isDisabled: p,
          isExpanded: S.isOpen,
          isFullWidth: !0,
          status: i === "error" ? Je.danger : void 0,
          children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              xt,
              {
                placeholder: o,
                value: l === z.typeahead && c ? c : T,
                onClick: L,
                onChange: (f, k) => {
                  I(k), a?.(k);
                },
                onKeyDown: (f) => H(f),
                autoComplete: "off",
                innerRef: F,
                role: "combobox",
                isExpanded: S.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: l === z.typeaheadMulti && Array.isArray(c) && (g || /* @__PURE__ */ t(Ye, { ...C, children: c.map((f, k) => /* @__PURE__ */ t(
                  Qe,
                  {
                    onClick: (D) => {
                      D.stopPropagation(), n?.(f);
                    },
                    children: f
                  },
                  k
                )) }))
              }
            ),
            /* @__PURE__ */ t(St, { children: !!T && /* @__PURE__ */ t(
              N,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), I(""), a?.(""), F?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: m }),
        R && /* @__PURE__ */ t(In, { children: R })
      ]
    }
  );
};
var z = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(z || {});
const we = (e) => typeof e == "number" ? e + "px" : e, sa = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(ia, { ...n }) : /* @__PURE__ */ t(oa, { ...n, variant: e }), gt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, o] = E(!1), [s, d] = E(""), u = a === "multiselect", h = (p, m) => {
    u ? m.value.includes(p) ? m.onChange(m.value.filter((S) => S !== p)) : Array.isArray(m.value) ? m.onChange([...m.value, p]) : m.onChange([p]) : m.onChange(p === m.value ? "" : p);
  }, c = l.validators?.options?.options || [], y = l.annotations?.inputOptionLabels || {}, g = l.annotations?.inputOptionLabelsI18nPrefix, C = (p) => ne(e.t, y[p], p, g), R = (p) => c.filter(
    (m) => C(m).toLowerCase().includes(s.toLowerCase())
  ).map((m) => /* @__PURE__ */ t(
    ze,
    {
      selected: p === m,
      value: m,
      children: C(m)
    },
    m
  ));
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Q(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: p }) => /* @__PURE__ */ t(
        sa,
        {
          toggleId: l.name,
          onToggle: (m) => o(m),
          onClear: () => h("", p),
          onSelect: (m) => {
            const S = m.toString();
            h(S, p), Array.isArray(p.value) || o(!1);
          },
          selections: u && Array.isArray(p.value) ? p.value.map((m) => C(m)) : C(p.value),
          variant: u ? z.typeaheadMulti : c.length >= 10 ? z.typeahead : z.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (m) => (d(m), R(p.value)),
          children: R(p.value)
        }
      )
    }
  ) });
}, ca = (e) => {
  const { form: n, attribute: r } = e, a = De(r);
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    Wr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, U = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = De(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    Se,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ne(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(Q(a.name))
    }
  ) });
}, He = {
  text: U,
  textarea: ca,
  select: gt,
  "select-radiobuttons": ft,
  multiselect: gt,
  "multiselect-checkboxes": ft,
  "html5-email": U,
  "html5-tel": U,
  "html5-url": U,
  "html5-number": U,
  "html5-range": U,
  "html5-datetime-local": U,
  "html5-date": U,
  "html5-month": U,
  "html5-time": U,
  "multi-input": aa
}, tl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: o
}) => {
  const s = q(() => {
    if (!r.attributes)
      return [];
    const d = i ? r.attributes.filter(({ readOnly: u }) => !u) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((u) => ({
      group: u,
      attributes: d.filter(
        (h) => h.group === u.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return s.length === 0 ? null : /* @__PURE__ */ t(
    ea,
    {
      label: e("jumpToSection"),
      sections: s.filter((d) => d.attributes.length > 0).map(({ group: d, attributes: u }) => ({
        title: ne(e, d.displayHeader, d.name) || e("general"),
        panel: /* @__PURE__ */ v("div", { className: "pf-v5-c-form", children: [
          d.displayDescription && /* @__PURE__ */ t(Ce, { className: "pf-v5-u-pb-lg", children: ne(e, d.displayDescription, "") }),
          u.map((h) => /* @__PURE__ */ t(
            da,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: o,
              attribute: h
            },
            h.name
          ))
        ] })
      }))
    }
  );
}, da = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const o = n.watch(
    Q(i.name)
  ), s = q(() => ha(i), [i]), d = i.multivalued || pa(o) && i.annotations?.inputType === void 0 ? He["multi-input"] : He[s];
  return i.name === "locale" ? /* @__PURE__ */ t(
    ra,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    d,
    {
      t: e,
      form: n,
      inputType: s,
      attribute: i,
      renderer: r
    }
  );
}, ua = "text";
function ha(e) {
  if (Ut(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ma(n) ? n : ua;
}
const ma = (e) => typeof e == "string" && e in He, pa = (e) => Array.isArray(e) && e.length > 1, fa = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: gr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ v("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), yt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = E(!1);
  return /* @__PURE__ */ t(
    wn,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (o) => i(o),
      toggle: (o) => /* @__PURE__ */ t(
        me,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: o,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(sr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(xn, { children: r })
    }
  );
};
function ga(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const nl = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: o = !0,
    hasManageAccount: s = !0,
    hasUsername: d = !0
  } = {},
  kebabDropdownItems: u,
  dropdownItems: h = [],
  toolbarItems: c,
  toolbar: y,
  ...g
}) => {
  const { t: C } = _(), R = [];
  s && R.push(
    /* @__PURE__ */ t(
      st,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), o && R.push(
    /* @__PURE__ */ t(st, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const p = e.idTokenParsed?.picture;
  return /* @__PURE__ */ v(Sn, { ...g, children: [
    /* @__PURE__ */ t(Tn, { children: /* @__PURE__ */ t(En, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(cr, {}) }) }),
    /* @__PURE__ */ t(An, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ v(Rn, { children: [
      y,
      /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ v(_e, { children: [
        c?.map((m, S) => /* @__PURE__ */ t(W, { align: { default: "alignRight" }, children: m }, S)),
        /* @__PURE__ */ t(
          W,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options",
                dropDownItems: [...h, R],
                title: d ? ga(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...u || h,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: p || i?.src ? /* @__PURE__ */ t(Dn, { src: p, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(fa, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Ht = Xe("ErrorBoundaryContext", void 0), Wt = () => Ze(Ht);
class rl extends Un {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Ht.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const al = ({ children: e, fallback: n }) => {
  const { error: r } = Wt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ya(e, n, r) {
  const { showBoundary: a } = Wt();
  le(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((o) => {
      i.aborted || n(o);
    }).catch((o) => {
      console.error(o), i.aborted || a(o);
    }), () => l.abort();
  }, r);
}
const ba = () => {
  const { t: e } = _();
  return /* @__PURE__ */ t(On, { children: /* @__PURE__ */ t(kt, { "aria-label": e("spinnerLoading") }) });
}, va = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: o,
  icon: s,
  isDisabled: d = !1,
  children: u
}) => /* @__PURE__ */ v(Fn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: dr }) : a && /* @__PURE__ */ t(ct, { icon: s || Vt }),
  /* @__PURE__ */ t(Pn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Vn, { children: n }),
  /* @__PURE__ */ v(Mn, { children: [
    i && /* @__PURE__ */ t(
      N,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: d,
        children: i
      }
    ),
    u,
    o && /* @__PURE__ */ t(Ln, { children: o.map((h) => /* @__PURE__ */ t(
      N,
      {
        "data-testid": `${h.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: h.type || Ie.secondary,
        onClick: h.onClick,
        isDisabled: d,
        children: h.text
      },
      h.text
    )) })
  ] })
] }), Ca = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s
}) => {
  const { t: d } = _(), [u, h] = E(""), c = (g) => {
    h(g.trim()), s?.(g.trim());
  }, y = (g) => {
    g.key === "Enter" && c(u);
  };
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(ke, { "data-testid": "table-toolbar", children: /* @__PURE__ */ v(_e, { children: [
      i && /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v(xe, { "data-testid": i, children: [
        l,
        o && /* @__PURE__ */ t(
          Bn,
          {
            "data-testid": "table-search-input",
            placeholder: o,
            "aria-label": d("search"),
            value: u,
            onChange: (g, C) => {
              h(C);
            },
            onSearch: () => c(u),
            onKeyDown: y,
            onClear: () => c("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ t(_e, { children: n }) }),
    /* @__PURE__ */ t(Nn, {}),
    a,
    /* @__PURE__ */ t(ke, { children: r })
  ] });
}, bt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: o,
  onPerPageSelect: s
}) => {
  const { t: d } = _(), u = Math.round(a / l);
  return /* @__PURE__ */ t(
    _n,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${d("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: h,
        lastIndex: c
      }) => /* @__PURE__ */ v("b", { children: [
        h,
        " - ",
        c
      ] }),
      itemCount: r + u * l,
      page: u + 1,
      perPage: l,
      onNextClick: (h, c) => i((c - 1) * l),
      onPreviousClick: (h, c) => o((c - 1) * l),
      onPerPageSelect: (h, c, y) => s(y - 1, c),
      variant: n
    }
  );
}, ka = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s,
  ...d
}) => /* @__PURE__ */ t(
  Ca,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ v(j, { children: [
      r,
      /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, ...d }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, variant: "bottom", ...d }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: o,
    inputGroupOnEnter: s,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, vt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ v(j, { children: [
    e.cells.map((i, o) => /* @__PURE__ */ t(re, { children: jt(i) ? i.title : i }, `cell-${o}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(re, { isActionCell: !0, children: /* @__PURE__ */ t(kr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, Ia = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function wa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: o,
  onCollapse: s,
  canSelectAll: d,
  canSelect: u,
  isNotCompact: h,
  isRadio: c,
  ...y
}) {
  const { t: g } = _(), [C, R] = E(i || []), [p, m] = E([]), S = q(
    () => pr(
      C,
      n.map((b) => b.data),
      "id"
    ),
    [C, n]
  );
  le(() => {
    if (d) {
      const b = document.getElementsByName("check-all").item(0);
      if (b) {
        const x = b;
        x.indeterminate = S.length < n.length && S.length > 0;
      }
    }
  }, [C, d, n]);
  const T = (b) => {
    R(b), o?.(b);
  }, I = (b, x) => {
    if (c) {
      const F = x ? [n[b].data] : [];
      T(F);
    } else if (b === -1) {
      const F = S.map(
        (A) => B(A, "id")
      );
      T(
        x ? [...C, ...n.map((A) => A.data)] : C.filter(
          (A) => !F.includes(B(A, "id"))
        )
      );
    } else
      T(x ? [...C, n[b].data] : C.filter(
        (F) => B(F, "id") !== n[b].data.id
      ));
  };
  return /* @__PURE__ */ v(
    yr,
    {
      ...y,
      variant: h ? void 0 : br.compact,
      "aria-label": g(l),
      children: [
        /* @__PURE__ */ t(vr, { children: /* @__PURE__ */ v(ve, { children: [
          s && /* @__PURE__ */ t(Ve, { screenReaderText: g("expandRow") }),
          d && /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("selectAll"),
              select: c ? void 0 : {
                onSelect: (b, x) => {
                  I(-1, x);
                },
                isSelected: S.length === n.length
              }
            }
          ),
          e.map((b) => /* @__PURE__ */ t(
            Ve,
            {
              screenReaderText: g("expandRow"),
              className: b.transforms?.[0]().className,
              children: g(b.displayKey || b.name)
            },
            b.displayKey || b.name
          ))
        ] }) }),
        s ? n.map((b, x) => /* @__PURE__ */ t(ut, { children: x % 2 === 0 ? /* @__PURE__ */ v(ve, { children: [
          /* @__PURE__ */ t(
            re,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: p[x] ?? !1,
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (F, A, L) => {
                  s(L, A);
                  const H = [...p];
                  H[x] = L, m(H);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ v(ve, { isExpanded: p[x - 1] ?? !1, children: [
          /* @__PURE__ */ t(re, {}),
          /* @__PURE__ */ t(re, { colSpan: e.length, children: /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ t(Ia, { row: b }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(ut, { children: n.map((b, x) => /* @__PURE__ */ v(ve, { isExpanded: p[x], children: [
          u && /* @__PURE__ */ t(
            re,
            {
              select: {
                rowIndex: x,
                onSelect: (F, A, L) => {
                  I(L, A);
                },
                isSelected: !!C.find(
                  (F) => B(F, "id") === b.data.id
                ),
                variant: c ? "radio" : "checkbox",
                isDisabled: b.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function xa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: o,
  detailColumns: s,
  isRowDisabled: d,
  loader: u,
  columns: h,
  actions: c,
  actionResolver: y,
  searchTypeComponent: g,
  toolbarItem: C,
  subToolbar: R,
  emptyState: p,
  icon: m,
  isSearching: S = !1,
  ...T
}) {
  const { t: I } = _(), [b, x] = E([]), [F, A] = E(), [L, H] = E(), [V, f] = E(!1), [k, D] = Bt(
    localStorage,
    "pageSize",
    10
  ), [O, se] = E(k), [$, ce] = E(0), [G, Oe] = E(""), tt = J(), [fe, Gt] = E(0), nt = J(), rt = () => Gt(fe + 1), zt = Rt(), at = (w, P) => w.map((M) => {
    if ("cellFormatters" in M) {
      const Z = B(P, M.name);
      return M.cellFormatters?.reduce((de, ye) => ye(de), Z);
    }
    if (M.cellRenderer) {
      const Z = M.cellRenderer;
      return { title: /* @__PURE__ */ t(Z, { ...P }) };
    }
    return B(P, M.name);
  }), lt = (w) => {
    const P = (M) => s?.[0]?.enabled?.(M);
    return w.map((M, Z) => {
      const de = d ? d(M) : !1, ye = [
        {
          data: M,
          disableSelection: de,
          disableActions: de,
          selected: !!b.find((Zt) => B(Zt, "id") === B(M, "id")),
          isOpen: P(M) ? !1 : void 0,
          cells: at(h, M)
        }
      ];
      return s && ye.push({
        parent: Z * 2,
        cells: P(M) ? at(s, M) : []
      }), ye;
    }).flat();
  }, Fe = (w) => ["string", "number"].includes(typeof w) ? w.toString() : w instanceof Array ? w.map(Fe).join("") : typeof w == "object" ? Fe(
    Kn(w.title) ? w.title.props : Object.values(w)
  ) : "", it = q(
    () => G === "" || r ? void 0 : lt(L || []).filter(
      (w) => w.cells.some(
        (P) => P && Fe(P).toLowerCase().includes(G.toLowerCase())
      )
    ).slice($, $ + O + 1),
    [G, $, O]
  );
  ya(
    async () => {
      f(!0);
      const w = tt.current === "" && G !== "";
      return w && ce(0), tt.current = G, typeof u == "function" ? fe === nt.current && L ? L : await u(w ? 0 : $, O + 1, G) : u;
    },
    (w) => {
      nt.current = fe, r || (H(w), w.length > $ ? w = w.slice($, $ + O + 1) : ce(0));
      const P = lt(w);
      A(P), f(!1);
    },
    [
      fe,
      $,
      O,
      G,
      typeof u != "function" ? u : void 0
    ]
  );
  const Jt = () => c && fr(c).map((w, P) => (delete w.onRowClick, w.onClick = async (M, Z) => {
    await c[P].onRowClick(
      (it || F)[Z].data
    ) && (r || Oe(""), rt());
  }, w)), Yt = (w, P) => {
    X[P].isOpen = w, A([...X]);
  }, X = it || F, ge = !X || X.length === 0, Pe = G !== "" || S, Qt = s ? O * 2 : O, Xt = s ? (X?.length || 0) / 2 : X?.length || 0;
  return /* @__PURE__ */ v(j, { children: [
    (!ge || Pe) && /* @__PURE__ */ v(
      ka,
      {
        id: zt,
        count: Xt,
        first: $,
        max: O,
        onNextClick: ce,
        onPreviousClick: ce,
        onPerPageSelect: (w, P) => {
          ce(w), se(P), D(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Oe,
        inputGroupPlaceholder: I(n || ""),
        searchTypeComponent: g,
        toolbarItem: /* @__PURE__ */ v(j, { children: [
          C,
          " ",
          /* @__PURE__ */ t(W, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v(N, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(ur, {}),
            " ",
            I("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !V && !ge && /* @__PURE__ */ t(
            wa,
            {
              ...T,
              canSelectAll: l,
              canSelect: !!a,
              selected: b,
              onSelect: (w) => {
                x(w), a?.(w);
              },
              onCollapse: s ? Yt : void 0,
              actions: Jt(),
              actionResolver: y,
              rows: X.slice(0, Qt),
              columns: h,
              isNotCompact: i,
              isRadio: o,
              ariaLabelKey: e
            }
          ),
          !V && ge && Pe && /* @__PURE__ */ t(
            va,
            {
              hasIcon: !0,
              icon: m,
              isSearchVariant: !0,
              message: I("noSearchResults"),
              instructions: I("noSearchResultsInstructions"),
              secondaryActions: S ? [] : [
                {
                  text: I("clearAllFilters"),
                  onClick: () => Oe(""),
                  type: Ie.link
                }
              ]
            }
          )
        ]
      }
    ),
    V && /* @__PURE__ */ t(ba, {}),
    !V && ge && !Pe && p
  ] });
}
const Sa = ({ link: e, organization: n }) => {
  const { t: r } = _();
  return /* @__PURE__ */ t(Ir, { wrapModifier: "truncate", children: /* @__PURE__ */ v(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      qn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ta = (e) => {
  const { t: n } = _();
  return /* @__PURE__ */ t(
    Ye,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Qe, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, ll = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: o,
  deleteLabel: s = "delete",
  link: d,
  children: u
}) => {
  const { t: h } = _();
  return /* @__PURE__ */ t(
    xa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: o ? [
        {
          title: h(s),
          onRowClick: o
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (c) => /* @__PURE__ */ t(Sa, { link: d, organization: c })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ta
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: u
    }
  );
};
export {
  Fr as AlertProvider,
  Ka as ContinueCancelModal,
  al as ErrorBoundaryFallback,
  rl as ErrorBoundaryProvider,
  Pr as ErrorPage,
  Xa as FileUploadControl,
  _t as FormErrorText,
  Jr as FormPanel,
  el as FormSubmitButton,
  Br as Help,
  qt as HelpItem,
  Za as IconMapper,
  xa as KeycloakDataTable,
  nl as KeycloakMasthead,
  $a as KeycloakProvider,
  sa as KeycloakSelect,
  ba as KeycloakSpinner,
  Wr as KeycloakTextArea,
  va as ListEmptyState,
  Ha as NumberControl,
  ll as OrganizationTable,
  ka as PaginatingTableToolbar,
  Wa as PasswordControl,
  $t as PasswordInput,
  ea as ScrollForm,
  Ur as SelectControl,
  ue as SelectVariant,
  Ja as SwitchControl,
  Ca as TableToolbar,
  Ya as TextAreaControl,
  Qa as TextControl,
  tl as UserProfileFields,
  ja as beerify,
  Xe as createNamedContext,
  Hr as debeerify,
  Er as generateId,
  Sr as getErrorDescription,
  xr as getErrorMessage,
  Ua as getInjectedEnvironment,
  Tr as getNetworkErrorDescription,
  Mt as getNetworkErrorMessage,
  Ar as isDefined,
  za as isUserProfileError,
  ne as label,
  Zr as mainPageContentId,
  Ga as setUserProfileServerError,
  _a as useAlerts,
  qa as useEnvironment,
  Wt as useErrorBoundary,
  ya as useFetch,
  Lr as useHelp,
  Ze as useRequiredContext,
  Rr as useSetTimeout,
  Bt as useStoredState
};
